module.exports = __webpack_public_path__ + "static/media/test.5a6159e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test.mp4
// module id = 2FWA
// module chunks = 1